import { ReactNode, useEffect, useRef, useState } from "react";
import cx from "classnames";

import styles from "../styles/FilterLayout.module.less";

type FilterLayoutProps = {
  panel: ReactNode;
  children: ReactNode;
};

const FilterLayout = ({ panel, children }: FilterLayoutProps) => {
  const panelRef = useRef<HTMLDivElement>(null);
  const [hasMoreBelow, setHasMoreBelow] = useState(false);
  const hasPanel = !!panel;

  useEffect(() => {
    const element = panelRef.current;
    if (!element) {
      return undefined;
    }
    const update = () =>
      setHasMoreBelow(element.scrollHeight - element.clientHeight - element.scrollTop > 1);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    if (element.firstElementChild) {
      observer.observe(element.firstElementChild);
    }
    element.addEventListener("scroll", update, { passive: true });
    return () => {
      observer.disconnect();
      element.removeEventListener("scroll", update);
    };
  }, [hasPanel]);

  return (
    <div className={cx(styles.layout, hasPanel && styles.withPanel)}>
      {hasPanel && (
        <div ref={panelRef} className={cx(styles.panelColumn, hasMoreBelow && styles.hasMoreBelow)}>
          {panel}
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default FilterLayout;
